import React from "react";
import "./About.css";

export const About = () => {
  return (
    <div>
      <br></br>
        <div class="aboutus">
          <h1 style={{ color: "#ffffff" }}>About SodiumHosting</h1>
          <p>SodiumHosting was founded in 2022 with the mission to provide top-quality gaming experiences to players around the world at an affordable price. As a dedicated hosting provider, we specialize in delivering powerful game servers that are optimized for low latency and high performance.</p>
          <p>At SodiumHosting, we believe that everyone should have access to high-quality gaming experiences, which is why we strive to keep our prices reasonable and accessible. We understand the importance of fast, stable, and reliable servers, which is why we've invested in the latest technology to bring our customers the best possible experience.</p>
          <p>We are a small team of dedicated professionals who are passionate about gaming and committed to providing the best possible customer support. Whether you have a question about our services or you need help setting up your server, we are here to help. Our goal is to make your experience with SodiumHosting as seamless and enjoyable as possible.</p>
          <p>Thank you for considering SodiumHosting for your gaming hosting needs. We look forward to serving you!</p>
        </div>
      <br></br> 
    </div>
  );
};
